import { Navigate, Route, Routes } from 'react-router';
import { useSelector } from 'react-redux';

import { selectUserRoles } from '@store/auth';

import ApplicationTemplate from '@dashboardComponents/ApplicationTemplate/ApplicationTemplate';

import MainDashboard from './pages/MainDashboard/MainDashboard';

import Tab1IconPath from '@assets/images/monitoring-dashboard/bar-chart-1-64.png';
import Tab2IconPath from '@assets/images/monitoring-dashboard/load-balancer-1.png';
import Logs from '@assets/images/monitoring-dashboard/log-file.png';

import { SidePanelImage } from '../../components/styledComponents';
import GrafanaDashboard from '../../../src/components/GrafanaDashboard';

import { healthChecks, logExplorer } from './monitoring-dashboard.breadcrumbs';
import { ROLES } from '../../app/App.constants';
import { getFirstRoute } from '../../utils/utils';

function generateGrafanaURL(url, pageName) {
  return `${url}&from=now-24h&to=now&panelId=1&page=${pageName}`;
}

const LogExplorerPageName = 'PAGE_LOG_EXPLORER';
const monitoringHealthDBPageName = 'MONITORING_PAYMENT_HEALTH_DB';

const tabs = [
  {
    title: 'Main Dashboard',
    icon: (
      <SidePanelImage
        src={Tab1IconPath}
        alt="Main Dashboard"
      />
    ),
    path: 'main-dashboard',
    roles: [ROLES.ROLE_MONITORING_MAIN_DASHBOARD],
  },
  {
    title: 'Log Explorer',
    icon: <SidePanelImage src={Logs} />,
    path: 'log-explorer',
    roles: [ROLES.ROLE_MONITORING_LOG_EXPLORER],
  },
  {
    title: 'Load Balancer Dashboard',
    icon: (
      <SidePanelImage
        src={Tab2IconPath}
        alt="Load Balancer Dashboard"
      />
    ),
    path: 'lb-dashboard',
    roles: [ROLES.ROLE_MONITORING_LOAD_BALANCER_DASHBOARD],
  },
  {
    title: 'Load Balancer Logs',
    icon: (
      <SidePanelImage
        src={Tab2IconPath}
        alt="Load Balancer Logs"
      />
    ),
    path: 'lb-logs',
    roles: [ROLES.ROLE_MONITORING_LOAD_BALANCER_LOGS],
  },
  {
    title: 'Heath Checks',
    icon: (
      <SidePanelImage
        src={Tab1IconPath}
        alt="Health Checks"
      />
    ),
    path: 'health-checks',
    roles: [ROLES.ROLE_MONITORING_HEALTH_CHECK],
  },
  {
    title: 'Galaxy Transactions',
    icon: (
      <SidePanelImage
        src={Tab1IconPath}
        alt="Galaxy Transactions"
      />
    ),
    path: 'galaxy-transactions',
    roles: [ROLES.ROLE_MONITORING_GALAXY_TRANSACTIONS],
  },
  {
    title: 'Cashier Transactions',
    icon: (
      <SidePanelImage
        src={Tab1IconPath}
        alt="Cashier Transactions"
      />
    ),
    path: 'cashier-transactions',
    roles: [ROLES.ROLE_MONITORING_CASHIER_TRANSACTIONS],
  },
];

const MonitoringDashboard = () => {
  const userRoles = useSelector(selectUserRoles);
  const firstRoute = getFirstRoute(userRoles, tabs);

  return (
    <ApplicationTemplate menu={tabs}>
      <Routes>
        <Route
          path="/"
          exact
          element={
            <Navigate
              to={firstRoute}
              replace
            />
          }
        />
        <Route
          path="/main-dashboard"
          exact
          element={<MainDashboard />}
        />
        <Route
          path="log-explorer"
          exact
          element={
            <GrafanaDashboard
              title="Log Search"
              breadcrumb={logExplorer}
              path="search"
              url={`${process.env.REACT_APP_GRAFANA_LOG_EXPLORER}&from=now-24h&to=now&panelId=1&page=PAGE_LOG_EXPLORER`}
            />
          }
        />
        <Route
          path="/health-checks"
          exact
          element={
            <GrafanaDashboard
              title="Payment Health Dashboard"
              breadcrumb={healthChecks}
              path="health-checks"
              url={generateGrafanaURL(
                process.env.REACT_APP_GRAFANA_MONITORING_PAYMENT_HEALTH_DB,
                monitoringHealthDBPageName,
              )}
            />
          }
        />
        <Route
          path="/lb-dashboard"
          exact
          element={
            <GrafanaDashboard
              title="Load Balancer Dashboard"
              breadcrumb={[
                { label: 'Monitoring Dashboard', url: '/monitoring-dashboard' },
                { label: 'Load Balancer Dashboard', url: '/lb-dashboard' },
              ]}
              path="lb-dashboard"
              url={generateGrafanaURL(
                process.env.REACT_APP_GRAFANA_MONITORING_LB_DB,
                monitoringHealthDBPageName,
              )}
            />
          }
        />
        <Route
          path="/lb-logs"
          exact
          element={
            <GrafanaDashboard
              title="Load Balancer Logs"
              breadcrumb={[
                { label: 'Monitoring Dashboard', url: '/monitoring-dashboard' },
                { label: 'Load Balancer Logs', url: '/lb-logs' },
              ]}
              path="lb-logs"
              url={generateGrafanaURL(
                process.env.REACT_APP_GRAFANA_MONITORING_LB_LOGS,
                LogExplorerPageName,
              )}
            />
          }
        />
        <Route
          path="/galaxy-transactions"
          exact
          element={
            <GrafanaDashboard
              title="Galaxy Transactions Dashboard"
              breadcrumb={[
                { label: 'Monitoring Dashboard', url: '/monitoring-dashboard' },
                {
                  label: 'Galaxy Transactions Dashboard',
                  url: '/galaxy-transactions',
                },
              ]}
              path="galaxy-transactions"
              url={generateGrafanaURL(
                process.env.REACT_APP_GRAFANA_GALAXY_TRANSACTIONS_MONITORING,
                monitoringHealthDBPageName,
              )}
            />
          }
        />
        <Route
          path="/cashier-transactions"
          exact
          element={
            <GrafanaDashboard
              title="Cashier Transactions Dashboard"
              breadcrumb={[
                { label: 'Monitoring Dashboard', url: '/monitoring-dashboard' },
                {
                  label: 'Cashier Transactions Dashboard',
                  url: '/cashier-transactions',
                },
              ]}
              path="cashier-transactions"
              url={generateGrafanaURL(
                process.env.REACT_APP_GRAFANA_CASHIER_TRANSACTIONS_MONITORING,
                monitoringHealthDBPageName,
              )}
            />
          }
        />
      </Routes>
    </ApplicationTemplate>
  );
};

export default MonitoringDashboard;
